













import { Component } from 'vue-property-decorator'

import UiModal from '@/components/semantic-ui/Modal.vue'

@Component({
	components: {
		UiModal,
	},
})
export default class ImportingModal extends UiModal {

}

